export const px2rem = (px: number) => `${px / 16}rem`;
